import { makeBrowserLogs } from "merchant-portal-frontend/src/model/logger";

export const browserLogs = makeBrowserLogs();
